import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: false,
    name: 'values'
})
export class ValuesPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        const keys = [];
        for (const key in value) {
            if (Object.prototype.hasOwnProperty.call(value, key)) {
                keys.push(value[key]);
            }
        }
        return keys;
    }
}
